module.exports = __webpack_public_path__ + "media/images/tab-security-6df36409ab648468f40cb01640743eb2.png";